import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle, PlayCircle } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import TutorialModal from './TutorialModal';
import { TUTORIAL_STORAGE } from '../../config/tutorial';

/**
 * HelpMenu
 *
 * Small nav dropdown so users can always relaunch the tutorial after
 * they've completed or dismissed the welcome card.
 */
export default function HelpMenu() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const hasCompleted = (() => {
    try {
      return localStorage.getItem(TUTORIAL_STORAGE.COMPLETED) === 'true';
    } catch { return false; }
  })();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            data-testid="help-menu-trigger"
            aria-label={t('tutorial.helpMenu')}
            className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-slate-500 hover:text-[#12355B] dark:text-slate-400 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800 transition"
          >
            <HelpCircle className="w-5 h-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>{t('tutorial.helpMenu')}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            data-testid="help-menu-tutorial"
            onClick={() => setOpen(true)}
            className="cursor-pointer"
          >
            <PlayCircle className="w-4 h-4 mr-2 text-[#45C04A]" />
            {t('tutorial.howToUse')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {open && (
        <TutorialModal
          open={open}
          onClose={() => setOpen(false)}
          trigger={hasCompleted ? 'replay' : 'help'}
        />
      )}
    </>
  );
}
